import PageLayout from "@/pages/home/components/PageLayout";
import GallerySection from "@/pages/home/components/GallerySection";

export default function GalleryPage() {
  return (
    <PageLayout>
      <GallerySection />
    </PageLayout>
  );
}
